import React from "react";
import styles from "./UserContact.module.scss";
import { sendEventTracking } from "../../utils/GeneralUtils";
import SonicLink from "../../common/routing/SonicLink";

const UserContact: React.FC = () => {
  return (
    <div className={styles["user-contact"]}>
      掲載情報にはサイトの性質上、差異が発生する場合がございます。
      <br />
      ぜひ公式サイトなどの情報も併せてご確認ください。
      <br />
      情報修正や掲載依頼はお問い合わせからご連絡ください。
      <div>
        <SonicLink
          to="/contact"
          onClick={() =>
            sendEventTracking("click", "FacilityReport", "施設情報修正リンク")
          }
        >
          お問い合わせ
        </SonicLink>
      </div>
    </div>
  );
};

export default UserContact;
